import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getClientBetsCricketAPI } from "../service/cricket";

import moment from "moment";
import Loader from "./components/Loader";

export default function MatchPosition({ isBookMakerOnly }) {
  const [matchOdds, setMatchOdds] = useState(null);
  const [matchData, setMatchData] = useState([]);
  const [clientBets, setClientBets] = useState([]);
  const [betStatus, setBetStatus] = useState("MATCHED");

  const [totalLength, setTotalLength] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [uniqueUser, setUniqueUser] = useState([]);
  var gameType = "cricket";
  var eventId = params?.id;

  const getClientBets = async (betStatus_, username) => {
    setIsLoading(true)
    const { response } = await getClientBetsCricketAPI(
      eventId,
      false,
      betStatus_ ? betStatus_ : betStatus
    );
    if (response) {
      setUniqueUser(
        Array.from(new Set(response?.bets?.map((item) => item?.userName)))
      );
      if (username) {
        let filteredData = response;
        filteredData.bets = response.bets.filter(
          (item) => item.userName == username
        );
        setClientBets(filteredData);
      } else {
        setClientBets(response);
      }
      setIsLoading(false)
      const totalAmount = response?.bets?.reduce(
        (total, item) => total + item.amount,
        0
      );
      setTotalAmount(totalAmount);

      if (
        response.bets.length != 0 &&
        response.bets[0]?.upperLineExposure?.length > 0
      ) {
        setTotalLength(response.bets[0]?.upperLineExposure.length);
      }
    }
    setIsLoading(false)
  };
  useEffect(() => {
    getClientBets();
  }, []);

  const calculateExposure = (data) => {
    console.log(data)
    const exposureMap = {};
    data?.forEach((item) => {
      item.parentExposure?.forEach((exp) => {
        const team = exp.selectionName;
        if (!exposureMap[team]) {
          exposureMap[team] = 0;
        }
        exposureMap[team] += exp.exposure;
      });
    });
    const result = Object.keys(exposureMap).map((team) => ({
      teamName: team,
      Exp: exposureMap[team],
    }));
    return result;
  };

  const exposureResult = calculateExposure(clientBets?.bets);
  // console.log(exposureResult);



  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Match Bet Details </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">Match Bet Details</li>
              </ol>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card">
                <form id="myForm" method="post">
                  <input
                    type="hidden"
                    name="_csrf"
                    defaultValue="6e5520ef-aa19-42ad-8d08-c8d5bc40e87c"
                  />
                  <div className="card-header ">
                    <div className="form-row col-md-6">
                      <table
                        className="table table-bordered table-striped"
                        data-select2-id={6}
                      >
                        <tbody className="text-bold">

                          {exposureResult?.map((item) => (
                            <>
                              <tr ng-repeat="row in match_runner" className="ng-scope">
                                <td className="pt-1 pb-1 ng-binding">{item?.teamName}</td>
                                <td
                                  className={`pt-1 pb-1 ng-binding ${item?.Exp > 0 ? 'text-success' : 'text-danger'}`}
                                // ng-class="liveprofit[row.selectionId] > 0 ? 'text-success':'text-danger'"
                                >
                                  {item?.Exp?.toFixed(2)}
                                </td>
                              </tr>
                            </>
                          ))}
                          <tr>
                            <th>Client</th>
                            <th data-select2-id={4}>
                              <select
                                className="form-control"
                                required=""
                                id="name"
                                placeholder="Select Client"
                                name="client"
                                data-select2-id="name"
                                tabIndex={-1}
                                aria-hidden="true"
                                onChange={(e) =>
                                  getClientBets(betStatus, e.target.value)
                                }
                              >
                                <option value={false}>
                                  All Clients
                                </option>
                                {uniqueUser?.map((item, index) => (
                                  <option value={item} key={index}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                      <input
                        type="button"
                        className="form-control btn btn-primary"
                        id="btn"
                        name="submit"
                        hidden=""
                        defaultValue="Submit"
                      />
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <div>
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Client</th>
                                <th>Rate</th>
                                <th>Team</th>
                                <th>Mode</th>
                                <th>Amount</th>
                                <th>Date &amp; Time</th>

                                {clientBets &&
                                  clientBets?.bets &&
                                  clientBets?.bets?.length > 0 &&
                                  clientBets?.bets?.[0]?.upperLineExposure?.map(
                                    (item) => (
                                      <th>
                                        {item?.selectionName}
                                      </th>
                                    )
                                  )}
                              </tr>
                              <tr>
                                <th
                                  colSpan={7}
                                  className="text-indigo text-lg text-center"
                                >
                                  Total Amount {totalAmount}
                                </th>

                                {Array.from({ length: totalLength }).map((_, index) => {
                                  const total = clientBets?.bets?.reduce(
                                    (acc, item) =>
                                      acc + (item?.upperLineExposure[index]?.exposure || 0),
                                    0
                                  );

                                  return (
                                    <th
                                      key={index}
                                      style={{
                                        color: total < 0 ? "red" : total > 0 ? "blue" : "black",
                                      }}
                                    >
                                      {total}
                                    </th>
                                  );
                                })}

                              </tr>
                            </thead>
                            {isLoading ?
                              <tr>
                                <td colSpan={9}>
                                  <Loader isLoading={isLoading} />
                                </td>
                              </tr>
                              :
                              <>
                                <tbody>
                                  {clientBets?.bets
                                    ?.filter((item) => item?.marketName != "Normal")
                                    ?.map((item, index) => (
                                      <>
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>{item.userName}</td>
                                          <td>{item.rate}</td>
                                          <td>{item.runnerName}</td>
                                          <td>{item?.back ? "Khai" : "Lagai"}</td>
                                          <td>{item.amount}</td>
                                          <td>
                                            {moment(item?.placeDate + "Z").format(
                                              "DD-MM-YYYY HH:mm:ss"
                                            )}
                                          </td>
                                          {item?.upperLineExposure?.map((item) => (
                                            <td
                                              style={{
                                                color:
                                                  parseFloat(item?.exposure) < 0
                                                    ? "red"
                                                    : "blue",
                                              }}
                                            >
                                              {parseFloat(item?.exposure).toFixed(2)}
                                            </td>
                                          ))}
                                        </tr>
                                      </>
                                    ))}
                                </tbody>
                              </>}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /.card-body */}
                </form>
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div >
        {/* /.container-fluid */}
      </section >
    </div >
  );
}